import flatpickr from 'flatpickr'
import { Italian } from "flatpickr/dist/l10n/it"

import moment from "moment";

flatpickr("input.datetime", {
    locale: Italian,
    time_24hr: true,
    enableTime: true,
    dateFormat: "Y-m-d H:i:s",
    altInput: true,
    altFormat: "d/m/Y  H:i",
    minuteIncrement: 15,
    defaultDate: moment().startOf('hour').format(),
    minDate: moment().startOf('hour').format()
});

